import { useUpdate } from 'react-admin';
import { useGetAppConfig } from './useGetAppConfig';
import { useOnSettled } from './useOnSettled';
import { useForm } from 'react-hook-form';
import { useCallback, useEffect } from 'react';
import {
  Box,
  CircularProgress,
  Button,
  TextField,
} from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const schema = z.object({
  supportedVersionRange: z.coerce.string(),
});

export const SupportedNativeVersionRange = () => {
  const [updateConfig, { isLoading: isUpdatingTrialDuration }] =
    useUpdate('therapistAppConfig', { id: 'current' });

  const {
    remoteAppConfig: { supportedVersionRange },
  } = useGetAppConfig();

  const { onSettled } = useOnSettled();

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    reset,
    getValues,
    watch,
  } = useForm({
    resolver: zodResolver(schema as any),
    defaultValues: {
      supportedVersionRange,
    },
  });

  useEffect(() => {
    setValue('supportedVersionRange', supportedVersionRange);
  }, [supportedVersionRange, setValue]);

  const doSubmit = useCallback(
    async (data: any) => {
      await updateConfig(
        'therapistAppConfig',
        {
          id: 'current',
          data,
        },
        {
          onSettled,
        },
      );

      reset(data);
    },
    [updateConfig, onSettled, reset],
  );

  const onSubmit = handleSubmit(doSubmit);

  const changed =
    supportedVersionRange !== getValues().supportedVersionRange;

  return (
    <Box marginTop="2rem">
      <h2>Supported Native Version Range</h2>
      <form onSubmit={onSubmit}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
        >
          <TextField
            label="Version Range"
            disabled={isUpdatingTrialDuration}
            error={!!formState.errors.supportedVersionRange}
            InputLabelProps={{
              shrink: true,
              sx: { paddingBottom: '2rem' },
            }}
            {...register('supportedVersionRange', { required: true })}
          />
          {(formState.isDirty || formState.isSubmitting) && (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isUpdatingTrialDuration || !formState.isValid}
              endIcon={
                isUpdatingTrialDuration && (
                  <CircularProgress size={14} />
                )
              }
            >
              {isUpdatingTrialDuration ? 'Updating' : 'Update'}{' '}
              Supported Native Version Range
            </Button>
          )}
        </Box>
      </form>
    </Box>
  );
};
